import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { badgeToneFor } from '@assist/design-tokens';
import { StatusIcon } from './StatusIcon.js';
export function Badge({ tone, badgeTone, children }) {
    const resolved = tone ?? badgeToneFor(badgeTone);
    return (_jsxs("span", { className: `assist-badge assist-badge--${resolved}`, children: [resolved !== 'neutral' ? _jsx(StatusIcon, { kind: resolved, size: 14 }) : null, _jsx("span", { children: children })] }));
}
//# sourceMappingURL=Badge.js.map